// `Symbol.asyncIterator` well-known symbol
// https://tc39.github.io/ecma262/#sec-symbol.asynciterator
require('../internals/define-well-known-symbol')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./~/@firebase/polyfill/~/core-js/modules/es.symbol.async-iterator.js
// module id = 283
// module chunks = 1